// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discount-drawer-overlay {
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(0, 0, 0, 0.28);
}

.discount-drawer-panel {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 80vw;
  
  background: #ffffff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px 20px;
  overflow-y: auto;
  animation: slideInRight 0.22s ease;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.discount-drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.discount-drawer-tag {
  font-size: 0.68rem;
  font-weight: 600;
  color: #9ca3af;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  margin: 0 0 4px 0;
}

.discount-drawer-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.discount-drawer-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: background 0.15s;
  margin-top: 2px;
}

.discount-drawer-close:hover {
  background: #f3f4f6;
  color: #111827;
}

.discount-type-toggle {
  display: flex;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 3px;
}

.discount-toggle-btn {
  flex: 1;
  border: none;
  background: transparent;
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.18s, color 0.18s, box-shadow 0.18s;
}

.discount-toggle-btn.active {
  background: #ffffff;
  color: #111827;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.discount-input-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.discount-input-label {
  font-size: 0.82rem;
  font-weight: 500;
  color: #374151;
}

.discount-input-row {
  display: flex;
  align-items: stretch;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 0.15s;
}

.discount-input-row:focus-within {
  border-color: #111827;
}

.discount-input-row.error,
.discount-input-row.error:focus-within {
  border-color: #dc2626;
}

.discount-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px 14px;
  font-size: 1rem;
  font-weight: 500;
  color: #111827;
  background: transparent;
}

.discount-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.discount-input::-webkit-outer-spin-button,
.discount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.discount-input-suffix {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  background: #f9fafb;
  border-left: 1.5px solid #e5e7eb;
  min-width: 44px;
}

.discount-input-hint {
  font-size: 0.72rem;
  color: #9ca3af;
  font-weight: 400;
  margin-top: 2px;
}

.discount-input-error {
  font-size: 0.72rem;
  color: #dc2626;
  font-weight: 500;
  margin-top: 2px;
}

.discount-quick-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.discount-pill {
  border: 1.5px solid #e5e7eb;
  border-radius: 999px;
  background: #ffffff;
  padding: 6px 16px;
  font-size: 0.82rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
  min-width: 54px;
  text-align: center;
}

.discount-pill:hover {
  border-color: #d1d5db;
  background: #f9fafb;
}

.discount-pill.selected {
  border-color: #16a34a;
  background: #f0fdf4;
  color: #15803d;
}

.discount-preview {
  background: #f9fafb;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.discount-preview-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.discount-preview-label {
  font-size: 0.82rem;
  color: #6b7280;
  font-weight: 500;
}

.discount-preview-value {
  font-size: 0.88rem;
  font-weight: 600;
}

.discount-preview-saving {
  color: #16a34a;
}

.discount-preview-divider {
  height: 1px;
  background: #e5e7eb;
}

.discount-preview-total-label {
  color: #111827;
  font-weight: 600;
}

.discount-preview-total-value {
  color: #111827;
  font-size: 1rem;
}

.discount-apply-btn {
  margin-top: auto;
  width: 100%;
  padding: 14px;
  background: #16a34a;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
}

.discount-apply-btn:hover:not(.disabled) {
  background: #15803d;
}

.discount-apply-btn:active:not(.disabled) {
  background: #166534;
}

.discount-apply-btn.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ── Dark mode ── */
.dark .discount-drawer-panel {
  background: #1e293b;
}

.dark .discount-drawer-tag {
  color: #64748b;
}

.dark .discount-drawer-title {
  color: #f1f5f9;
}

.dark .discount-drawer-close {
  color: #94a3b8;
}

.dark .discount-drawer-close:hover {
  background: #334155;
  color: #f1f5f9;
}

.dark .discount-type-toggle {
  background: #0f172a;
}

.dark .discount-toggle-btn {
  color: #64748b;
}

.dark .discount-toggle-btn.active {
  background: #1e293b;
  color: #f1f5f9;
  box-shadow: 0 1px 4px rgba(0,0,0,0.4);
}

.dark .discount-input-label {
  color: #cbd5e1;
}

.dark .discount-input-row {
  border-color: #334155;
  background: #0f172a;
}

.dark .discount-input-row:focus-within {
  border-color: #3b82f6;
}

.dark .discount-input {
  color: #f1f5f9;
}

.dark .discount-input-suffix {
  background: #1e293b;
  border-left-color: #334155;
  color: #94a3b8;
}

.dark .discount-input-hint {
  color: #64748b;
}

.dark .discount-pill {
  border-color: #334155;
  background: #0f172a;
  color: #cbd5e1;
}

.dark .discount-pill:hover {
  border-color: #475569;
  background: #1e293b;
}

.dark .discount-pill.selected {
  border-color: #16a34a;
  background: #052e16;
  color: #4ade80;
}

.dark .discount-preview {
  background: #0f172a;
  border-color: #334155;
}

.dark .discount-preview-label {
  color: #94a3b8;
}

.dark .discount-preview-divider {
  background: #334155;
}

.dark .discount-preview-total-label,
.dark .discount-preview-total-value {
  color: #f1f5f9;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/DiscountDrawer/DiscountDrawer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;;EAEX,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".discount-drawer-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  background: rgba(0, 0, 0, 0.28);\n}\n\n.discount-drawer-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 80vw;\n  \n  background: #ffffff;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px 20px;\n  overflow-y: auto;\n  animation: slideInRight 0.22s ease;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.discount-drawer-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.discount-drawer-tag {\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: #9ca3af;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  margin: 0 0 4px 0;\n}\n\n.discount-drawer-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n}\n\n.discount-drawer-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: background 0.15s;\n  margin-top: 2px;\n}\n\n.discount-drawer-close:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.discount-type-toggle {\n  display: flex;\n  background: #f3f4f6;\n  border-radius: 999px;\n  padding: 3px;\n}\n\n.discount-toggle-btn {\n  flex: 1;\n  border: none;\n  background: transparent;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: background 0.18s, color 0.18s, box-shadow 0.18s;\n}\n\n.discount-toggle-btn.active {\n  background: #ffffff;\n  color: #111827;\n  font-weight: 600;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n\n.discount-input-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.discount-input-label {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.discount-input-row {\n  display: flex;\n  align-items: stretch;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: border-color 0.15s;\n}\n\n.discount-input-row:focus-within {\n  border-color: #111827;\n}\n\n.discount-input-row.error,\n.discount-input-row.error:focus-within {\n  border-color: #dc2626;\n}\n\n.discount-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  padding: 10px 14px;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #111827;\n  background: transparent;\n}\n\n.discount-input::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.discount-input::-webkit-outer-spin-button,\n.discount-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.discount-input-suffix {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 14px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #374151;\n  background: #f9fafb;\n  border-left: 1.5px solid #e5e7eb;\n  min-width: 44px;\n}\n\n.discount-input-hint {\n  font-size: 0.72rem;\n  color: #9ca3af;\n  font-weight: 400;\n  margin-top: 2px;\n}\n\n.discount-input-error {\n  font-size: 0.72rem;\n  color: #dc2626;\n  font-weight: 500;\n  margin-top: 2px;\n}\n\n.discount-quick-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.discount-pill {\n  border: 1.5px solid #e5e7eb;\n  border-radius: 999px;\n  background: #ffffff;\n  padding: 6px 16px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, color 0.15s;\n  min-width: 54px;\n  text-align: center;\n}\n\n.discount-pill:hover {\n  border-color: #d1d5db;\n  background: #f9fafb;\n}\n\n.discount-pill.selected {\n  border-color: #16a34a;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.discount-preview {\n  background: #f9fafb;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.discount-preview-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.discount-preview-label {\n  font-size: 0.82rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.discount-preview-value {\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.discount-preview-saving {\n  color: #16a34a;\n}\n\n.discount-preview-divider {\n  height: 1px;\n  background: #e5e7eb;\n}\n\n.discount-preview-total-label {\n  color: #111827;\n  font-weight: 600;\n}\n\n.discount-preview-total-value {\n  color: #111827;\n  font-size: 1rem;\n}\n\n.discount-apply-btn {\n  margin-top: auto;\n  width: 100%;\n  padding: 14px;\n  background: #16a34a;\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n}\n\n.discount-apply-btn:hover:not(.disabled) {\n  background: #15803d;\n}\n\n.discount-apply-btn:active:not(.disabled) {\n  background: #166534;\n}\n\n.discount-apply-btn.disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ── Dark mode ── */\n.dark .discount-drawer-panel {\n  background: #1e293b;\n}\n\n.dark .discount-drawer-tag {\n  color: #64748b;\n}\n\n.dark .discount-drawer-title {\n  color: #f1f5f9;\n}\n\n.dark .discount-drawer-close {\n  color: #94a3b8;\n}\n\n.dark .discount-drawer-close:hover {\n  background: #334155;\n  color: #f1f5f9;\n}\n\n.dark .discount-type-toggle {\n  background: #0f172a;\n}\n\n.dark .discount-toggle-btn {\n  color: #64748b;\n}\n\n.dark .discount-toggle-btn.active {\n  background: #1e293b;\n  color: #f1f5f9;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.4);\n}\n\n.dark .discount-input-label {\n  color: #cbd5e1;\n}\n\n.dark .discount-input-row {\n  border-color: #334155;\n  background: #0f172a;\n}\n\n.dark .discount-input-row:focus-within {\n  border-color: #3b82f6;\n}\n\n.dark .discount-input {\n  color: #f1f5f9;\n}\n\n.dark .discount-input-suffix {\n  background: #1e293b;\n  border-left-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .discount-input-hint {\n  color: #64748b;\n}\n\n.dark .discount-pill {\n  border-color: #334155;\n  background: #0f172a;\n  color: #cbd5e1;\n}\n\n.dark .discount-pill:hover {\n  border-color: #475569;\n  background: #1e293b;\n}\n\n.dark .discount-pill.selected {\n  border-color: #16a34a;\n  background: #052e16;\n  color: #4ade80;\n}\n\n.dark .discount-preview {\n  background: #0f172a;\n  border-color: #334155;\n}\n\n.dark .discount-preview-label {\n  color: #94a3b8;\n}\n\n.dark .discount-preview-divider {\n  background: #334155;\n}\n\n.dark .discount-preview-total-label,\n.dark .discount-preview-total-value {\n  color: #f1f5f9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
